// Per-room session tokens issued by the server in the welcome message.
// localStorage (not sessionStorage) on purpose: a second tab must be able to
// present the same token to take over the session.
const KEY_PREFIX = 'curvegen.session.';

function sessionKey(roomId) {
  return `${KEY_PREFIX}${String(roomId || '').trim()}`;
}

function storeSession(roomId, token, name) {
  if (!roomId || typeof token !== 'string' || !token) return;
  try {
    window.localStorage.setItem(sessionKey(roomId), JSON.stringify({
      token,
      name: typeof name === 'string' ? name : '',
      savedAt: Date.now()
    }));
  } catch (_) {
    // Storage unavailable (private mode etc.); reconnect degrades to fresh join.
  }
}

function readSession(roomId) {
  if (!roomId) return null;
  try {
    const raw = window.localStorage.getItem(sessionKey(roomId));
    if (!raw) return null;
    const value = JSON.parse(raw);
    if (!value || typeof value.token !== 'string' || !value.token) return null;
    return value;
  } catch (_) {
    return null;
  }
}

function clearSession(roomId) {
  if (!roomId) return;
  try {
    window.localStorage.removeItem(sessionKey(roomId));
  } catch (_) {
  }
}

export {
  clearSession,
  readSession,
  storeSession
};
